import React from 'react';
import { Card, Select, Form } from 'antd';
import IntlMessages from 'util/IntlMessages';

const { Option } = Select;

/**
 * Renders Setting Options Card in ManageUheBedCart file
 * @param {Object} bedCart bedCart
 * @param {function} onChangeOption onChangeOption
 * @param {boolean} loading loading
 * @returns {JSX} React Element
 */
function SettingOptionsCard({
  bedCart, onChangeOption, loading, layout,
}) {
  const filledArray = new Array(20).fill(null);

  return (
    <Card
      className="gx-card options-card"
      title={<IntlMessages id="configuration.bedsCarts.options.title" />}
      loading={loading}
    >
      <Form.Item
        {...layout}
        className="gx-align-items-center setting-options-label"
        label={<IntlMessages id="configuration.bedsCarts.options.mic" />}
      >
        <Select
          name="default_input"
          value={bedCart.default_input}
          onChange={(e) => {
            onChangeOption(e, 'default_input');
          }}
        >
          {filledArray.map((_, idx) => <Option value={idx + 1} key={idx}>{idx + 1}</Option>)}
        </Select>
      </Form.Item>
      <Form.Item
        {...layout}
        className="gx-align-items-center setting-options-label"
        label={<IntlMessages id="configuration.bedsCarts.options.speaker" />}
      >
        <Select
          value={bedCart.default_output}
          onChange={(e) => {
            onChangeOption(e, 'default_output');
          }}
        >
          {filledArray.map((_, idx) => <Option value={idx + 1} key={idx}>{idx + 1}</Option>)}
        </Select>
      </Form.Item>
      <Form.Item
        {...layout}
        className="gx-align-items-center setting-options-label"
        label={<IntlMessages id="configuration.bedsCarts.options.bell" />}
      >
        <Select
          value={bedCart.default_bell}
          onChange={(e) => {
            onChangeOption(e, 'default_bell');
          }}
        >
          {filledArray.map((_, idx) => <Option value={idx + 1} key={idx}>{idx + 1}</Option>)}
        </Select>
      </Form.Item>
      <Form.Item
        {...layout}
        className="gx-align-items-center setting-options-label"
        label={<IntlMessages id="configuration.bedsCarts.options.camSpeed" />}
      >
        <Select
          value={bedCart.default_speed}
          onChange={(e) => {
            onChangeOption(e, 'default_speed');
          }}
        >
          {filledArray.map((_, idx) => <Option value={idx + 1} key={idx}>{idx + 1}</Option>)}
        </Select>
      </Form.Item>
    </Card>
  );
}

export default SettingOptionsCard;
